/**
 * 图片地址兜底表。
 *
 * 素材现在有两个地址：图床公网 URL（用于显示与喂上游）和本站相对地址（本地副本）。
 * 图床的图有可能被删、被限流、被墙——那时 img 就变成碎图标。
 * 这里维护「主地址 → 本地副本地址」的映射，img onError 时自动换到本地副本。
 *
 * 为什么用模块级 Map 而不是 Context：
 * Thumbs / SmartImage 是纯展示组件，满项目都在用。
 * 为了一个 onError 兜底把它们全改成吃 Context，耦合收益不成正比。
 */

const fallback = new Map<string, string>()

export function rememberFallback(url: string, local?: string | null) {
  if (!url || !local || url === local) return
  fallback.set(url, local)
}

export function rememberAsset(item: { url: string; localUrl?: string | null }) {
  rememberFallback(item.url, item.localUrl)
}

/** 主地址加载失败时的备选地址；没有则返回 undefined（调用方自行降级成占位图）。 */
export function fallbackOf(url: string): string | undefined {
  return fallback.get(url)
}
